<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" @stored="storeUser" :visibleStore="updatePermission">
                    <template v-slot:action="{ item }">
                        <v-btn v-if="updatePermission" class="mr-2" depressed small @click.stop="updatedUser(item)" color="primary">編集</v-btn>
                        <v-btn v-if="deletePermission" class="mr-2" depressed small @click.stop="deleteUser(item)" color="error">削除</v-btn>
                    </template>
                </custom-data-table>
            </v-col>
        </v-row>
        <v-row justify="center">
            <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
                @deleted="deleted" @canceled="dialogCancel"/>
        </v-row>
    </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import TemplateApi from "@/api/template-api";
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CustomDialog from "@/components/custom_ui/CustomDialog";

  export default {
    name: "ExpenseTemplate",
    components: {
      CustomDataTable,
      CustomDialog
    },
    props: ["user"],
    data: () => ({
        // 費目テンプレートテーブル
        loading: false,
        tableName: "費目テンプレート情報",
        headers: [
            { text: "テンプレート名", value: "name" },
            { text: "更新日", value: "update_date" },
            { text: "アクション", value: "action" }
        ],
        items: [],

        // 削除ダイアログ
        dialogMaxWith: 500,
        dialogTitle: "",
        dialogItems: [],
        dialogDrawer: false,
        deleteId: null,

        // 権限
        updatePermission: true,
        deletePermission: true
    }),
    created() {
        this.initialize();
    },
    methods: {
        isLoading() {
            this.loading = !this.loading;
            this.$emit("loading", this.loading);
        },
        initialize() {
            this.isLoading();
            if (this.user.role_id == 0) {
                this.updatePermission = this.user.permission_config.CTSG00008.update;
                this.deletePermission = this.user.permission_config.CTSG00008.delete;
            }
            this.templateApi = new TemplateApi();
            const promise = this.templateApi.list();
            promise.then((response) => {
                this.items = response.data.body.template_list;
            }).catch(error => {
                useAppInsights().trackException({exception: error});
                if (error.response) {
                    if (error.response.data.status == statusList.status.authError) {
                        this.$emit('logoutConform');
                    } else if (error.response.data.status == statusList.status.entityError) {
                        this.$emit("error",error.response.data.message);
                        this.$router.push({ name: "Dashboard" })
                    } else {
                        this.$emit("error",error.response.data.message);
                    }
                } else {
                    this.$emit("error","サーバーエラーが発生しました。");
                }
            }).finally(() => {
                this.isLoading();
            });
        },
        storeUser() {
            this.$router.push({ name: 'ExpenseTemplateEntry' });
        },
        updatedUser(item) {
            this.$router.push({ name: 'ExpenseTemplateEdit', params: { id: item.id } });
        },
        deleteUser(item) {
            this.deleteId = item.id;
            this.dialogTitle = '削除しますか？';
            this.dialogItems = [
                { name: "テンプレート名", value: item.name }
            ];
            this.dialogDrawer = true;
        },
        dialogCancel() {
            this.dialogDrawer = false;
        },
        deleted() {
            this.isLoading();
            const promise = this.templateApi.delete(this.deleteId);
            promise.then((response) => {
                this.items = this.items.filter((item) => {
                    return (item.id !== this.deleteId);
                });
                this.deleteId = null;
                this.dialogDrawer = false;
                this.$emit('success', response.data.message);
            }).catch(error => {
                useAppInsights().trackException({exception: error});
                if(error.response){
                    if(error.response.data.status == statusList.status.authError){
                        this.dialogDrawer = false;
                        this.$emit('logoutConform');
                    } else {
                        this.$emit("error",error.response.data.message);
                    }
                }else{
                    this.$emit("error","サーバーエラーが発生しました。");
                }
            }).finally(() => {
                this.isLoading();
            });
        }
    }
  }
</script>
